// extracted by mini-css-extract-plugin
module.exports = {"inputOption":"InputOption_inputOption__7ahcS","InputOptionsIconImage":"InputOption_InputOptionsIconImage__l95Bs","text":"InputOption_text__3X_Du"};